import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIcons4dComponent } from './simple-icons-4d.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIcons4dComponent ],
    exports:      [ SimpleIcons4dComponent ],
    bootstrap:    []
})
export class SimpleIcons4dModule {}
